<template>
  
  <div :class="{'main-panel': $store.state.user.role != 'user' || !hasPatients}">
    <div :class="{'main-content': $store.state.user.role != 'user' || !hasPatients}">
      <div :class="{'content-wrapper': $store.state.user.role != 'user' || !hasPatients}">
        <div :class="{'container-fluid': $store.state.user.role != 'user' || !hasPatients}">
          <seizure-search v-if="$store.state.user.role === 'admin' || $store.state.user.role === 'dravetnet'"></seizure-search>
          <div class="row full-height-vh" v-if="$store.state.user.role === 'user' && !hasPatients">
            <div class="col-12 d-flex align-items-center justify-content-center">
              <div class="card px-4 py-2 box-shadow-2 width-400">
                <div class="card-header text-center">
                  <div class="row">
                    <div class="text-center col-md-12">
                      <svg xmlns="http://www.w3.org/2000/svg" id="add-patient-icon" viewBox="0 0 512 512" @click.prevent="gotoNewPatient">
                        <g>
                          <title>{{ $t("labels.addFirstPatient") }}</title>
                          <path d="M422.249,352H391V321a8.8,8.8,0,0,0-8.751-9h-28A9.227,9.227,0,0,0,345,321v31H313.249A9.227,9.227,0,0,0,304,361v28a9.227,9.227,0,0,0,9.249,9H345v32a9.227,9.227,0,0,0,9.249,9h28A8.8,8.8,0,0,0,391,430V398h31.249A8.8,8.8,0,0,0,431,389V361A8.8,8.8,0,0,0,422.249,352ZM417,384H386.249A9.227,9.227,0,0,0,377,393v32H359V393a8.8,8.8,0,0,0-8.751-9H318V366h32.249A8.8,8.8,0,0,0,359,357V326h18v31a9.227,9.227,0,0,0,9.249,9H417Z"/>
                          <path d="M369.83,253.158a119.865,119.865,0,0,0-98.4,51.466q-2.828-.87-5.351-1.692l-6.794-19.27c21-15.733,26.752-40.3,28.322-52.2,14.122-3.831,27.091-20.424,32.287-42.413,2.8-11.893-1.3-22.966-10.206-27.555a17.462,17.462,0,0,0-7.98-1.936c.46-3.451.94-7.672,1.437-12.855,1.162-12.127,1.9-24.376,1.9-27.48,0-2.2.044-4.468.09-6.869.371-19.149.832-42.979-20.29-64.343h0c-18.956-19.172-45.792-29.741-73.617-28.972-27.719.758-53.712,12.586-71.316,32.451q-.81.917-1.646,1.846C127.648,65.2,113.105,81.449,114.149,123.06c.1,4.073,4,22.739,8.039,36.965a17.632,17.632,0,0,0-6.714,2.074c-8.549,4.62-12.469,15.45-9.755,26.951,5.2,22.027,18.211,38.64,32.365,42.429,1.692,11.67,7.615,35.994,28.079,51.74L157.2,301.651c-6.4,2.006-13.613,3.993-21.058,6.079C88.023,321.217,22,339.686,22,399.689v62.738C22,477.248,29.927,493,44.156,493H370.249c.065,0,.128-.008.192-.01a119.917,119.917,0,0,0-.611-239.832ZM148.7,62.669q.858-.958,1.693-1.9c15.044-16.978,37.357-27.089,61.219-27.741,23.977-.666,47.037,8.392,63.279,24.821,16.966,17.159,16.585,36.852,16.249,54.227-.048,2.472-.093,4.807-.093,7.141,0,1.484-.15,4.563-.406,8.48-3.385-12.583-8.118-24.736-14.635-31.842l-.518-1.036a7,7,0,0,0-12.634.233c-11.279,24.809-22.452,23.81-40.962,22.159-2.149-.192-4.335-.387-6.557-.541-7.043-.5-9.591,3.616-10.36,5.4-2.282,5.3.889,11.023,6.694,17.809-18.479-2.206-23.163-15.722-27.383-27.914-2.929-8.462-6.248-18.054-15.9-18.054a32.606,32.606,0,0,0-24.769,10.671c-7.173,7.7-11.215,18.678-13.465,29.436a88.6,88.6,0,0,1-2-11.314C127.239,86.648,138.64,73.908,148.7,62.669Zm2.747,162.344a7.048,7.048,0,0,0-7-6.718c-.1,0-.2,0-.305,0-10.252,0-21.077-16.724-24.8-32.465-1.425-6.04.446-10.153,2.787-11.419,2.647-1.428,5.47,1.087,6.56,2.236a7,7,0,0,0,12.026-3.987,6.972,6.972,0,0,0,.909-3.961c-.744-10.737.007-41.473,12.24-54.582a18.735,18.735,0,0,1,13.68-6.19c1.052,1.519,2.456,5.574,3.509,8.619,5.188,14.988,14.844,42.88,57.636,36.775a7,7,0,0,0,3.748-12.084,127.062,127.062,0,0,1-9.649-9.892c16.457,1.429,33.244,1.967,47.118-19.864,8.768,16.444,13.333,49.143,14.451,62.128a7,7,0,0,0,6.967,6.4c.2,0,.4-.009.607-.027a6.994,6.994,0,0,0,5.844-4.244c1.382-1.366,3.49-2.84,5.5-1.807,2.568,1.323,4.42,5.836,2.993,11.9-3.721,15.744-14.545,32.467-24.8,32.467l-.175,0a7.056,7.056,0,0,0-3.848,1.068,6.979,6.979,0,0,0-3.283,5.731c-.3,5.724-3.011,34.993-26.861,49.816-.039.023-.075.049-.113.073-9.286,5.729-20.854,8.635-34.383,8.635-13.492,0-25.034-2.972-34.31-8.836C154.984,259.94,151.838,230.72,151.446,225.013Zm17.031,85.458,9.7-19.944c10.045,4.706,21.652,7.092,34.628,7.092,12.788,0,24.241-2.266,34.18-6.732l7.026,19.929a7,7,0,0,0,4.343,4.3q2.616.892,5.539,1.821a119.1,119.1,0,0,0-8.458,20.144c-6.478,7.672-20.073,19.407-42.63,19.407a54.158,54.158,0,0,1-40.53-17.582c-7.384-7.92-11.563-16.749-12.972-23.251,1.717-.527,3.4-1.055,5.044-1.589A7,7,0,0,0,168.477,310.471ZM36,462.427V399.689c0-49.387,57.675-65.517,103.918-78.478,1.957-.549,3.948-1.09,5.852-1.627,5.065,21.278,27.882,50.9,67,50.9a68.816,68.816,0,0,0,37.872-10.79A119.951,119.951,0,0,0,313.657,479H44.156C39.7,479,36,470.091,36,462.427ZM369.83,479A105.92,105.92,0,1,1,475.751,373.079,106.039,106.039,0,0,1,369.83,479Z"/>
                        </g> 
                      </svg>
                      <h5>{{ $t("labels.noPatients") }}</h5>
                      <button
                        @click.prevent="gotoNewPatient"
                        type="submit"
                        class="btn btn-danger px-4 py-2 text-uppercase white font-small-4 border-0"
                      >{{ $t("labels.addFirstPatient") }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <show-patient  v-if="$store.state.user.role === 'user' && hasPatients"></show-patient>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SeizureForm from '@/components/seizure/SeizureForm.vue'
import Progress from '@/components/patient/Progress.vue'
import SeizureSearch from  '@/components/search/Seizure'
import SeizureService from '@/services/seizure'
import ShowPatient from '@/components/patient/Show.vue'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: {
    SeizureForm,
    Progress,
    SeizureSearch,
    ShowPatient
  },
  data(){
    return {
      errors: [],
      hasPatients: false,
      isLoading: false,
      fullPage: true,
      selectedPatient: {},
      selectedPatientSeizures: [],
      selectedDrug: {},
      selectedDrugQuantity: 1,
      seizureFormVisibility: false,
      seizure: {
        patient: {
          seizures: []
        },
        notes: ``,
        type: {},
        drug: [],
        blockedWithDrugs: false,
        patiendId: '',
        occuredOn: ''
      }
    }
  },
  computed: {
    currentRoute() {
      return this.$route.name
    }
  },
  methods: {
    gotoNewPatient() {
      this.$router.push({ name: 'newPatient' })
    },
    goToPatient(id) {
      this.$router.push({ name: 'showPatient', params: {id: id } })
    },
    seizureFormVisibilityControl() {
      this.seizureFormVisibility = true
      console.log(this.seizureFormVisibility)
    },
    createSeizure: async function() {
      this.errors = []
      let loader = this.$loading.show({
        color: '#ccc',
        loader: 'spinner'
      },{
        after: this.$createElement('Progress')
      })
      if (!this.seizure.patientId || this.seizure.patientId.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("models.patient")]))
      }
      if (!this.seizure.occuredOn || this.seizure.occuredOn.length === 0) {
        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.occuredOn")]))
      }
      if (!this.seizure.duration) {
        this.errors.push(this.$t("errors.validDuration"))
      }
      if (this.seizure.blockedWithDrugs === true) {
        if (!this.seizure.drug || this.seizure.drug.length === 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("models.drug")]))
        }
      }
      if (this.seizure.video && this.seizure.video.type) {
        if (!this.$store.state.allowedVideoTypes.includes(this.seizure.video.type)) {
          this.errors.push(this.$t("errors.wrongFiletype", [this.seizure.video.name]))
        }
        let videSizeMb = this.seizure.video.size/1024/1024
        if (videSizeMb > 50 ) {
          this.errors.push(this.$t("errors.tooLarge", [this.seizure.video.name]))
        }
      }
      if (this.seizure.uploadImages && Array.isArray(this.seizure.uploadImages && this.seizure.uploadImages.length > 0)) {
        _.forEach(this.seizure.uploadImages, img => {
            if (!this.$store.state.allowedImageTypes.includes(img.type)) {
              this.errors.push(img.name + " has wrong filetype.")
            }
            let imageSizeMb = img.size/1024/1024
            if (imageSizeMb > 5) {
              this.errors.push(this.$t("errors.tooLarge", [img.name]))
            }
        })
      }
      if (this.errors.length === 0) {
        let formData = new FormData()
        formData.append('video', this.seizure.video)
        _.forEach(this.seizure.uploadImages, img => {
          formData.append('image', img)
        })
        formData.append('seizure', JSON.stringify(this.seizure))
        this.seizure.type = JSON.parse(this.seizure.type)
        this.seizure.duration = JSON.parse(this.seizure.duration)
        if (this.seizure.triggeringFactor) {
          this.seizure.triggeringFactor = JSON.parse(this.seizure.triggeringFactor)
        }
        let result = await SeizureService.create(formData)
        if (result.data.success === true) {
          this.seizureFormVisibility = false
          this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.seizure")]))
          let seizures = await SeizureService.patientSeizures(this.seizure.patientId)
          this.selectedPatientSeizures = seizures.data
          let defaultPatient = this.$store.state.patients.find(o => o.default === true)
          this.seizure = {
            patient: {
              seizures: []
            },
            notes: ``,
            type: {},
            drug: [],
            blockedWithDrugs: false,
            patientId: defaultPatient._id,
            image: [],
            video: [],
            occuredOnDate: moment(new Date()).format('YYYY-MM-DD'),
            occuredOnTime: moment(new Date()).format('HH:mm')
          }
          this.$refs.newseizure.resetFiles()
          this.precompiledSeizure()
        } else {
          this.$miniToastr.error(this.$t("flash.createFailed", [this.$t("models.seizure")]))
        }
      } else {
        this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
      }
      loader.hide()
      this.$store.state.currentProgress = 0
    },
    changePatient: async function() {
      let patient = await this.$store.state.patients.find(o => o._id === this.seizure.patientId)
      this.selectedPatient = patient
      let seizures = await SeizureService.patientSeizures(this.seizure.patientId)
      this.selectedPatientSeizures = seizures.data
      this.precompiledSeizure()
      //this.selectedPatientSeizures = this.selectedPatientSeizures.sort(function(a,b){
      //  return new Date(b.occuredOn) - new Date(a.occuredOn)
      //})
    },
    precompiledSeizure() {
      if (this.selectedPatientSeizures.length > 0) {
        this.seizure.type = JSON.stringify(this.selectedPatientSeizures[0].type)
        this.seizure.duration = this.selectedPatientSeizures[0].duration
        this.seizure.status = this.selectedPatientSeizures[0].status
        this.seizure.occuredOn = this.selectedPatientSeizures[0].occuredOn
        this.seizure.triggeringFactor = JSON.stringify(this.selectedPatientSeizures[0].triggeringFactor)
        this.seizure.duration = JSON.stringify(this.selectedPatientSeizures[0].duration)
        //this.seizure.blockedWithDrugs = this.selectedPatientSeizures[0].blockedWithDrugs
        //this.seizure.drug = this.selectedPatientSeizures[0].drug
      }
    },
    formatDate(d) {
      return moment(new Date(d)).format("DD/MM/YYYY HH:mm")
    },
    formatDateNoTime(d) {
      return moment(new Date(d)).format("DD/MM/YYYY")
    }
  },
  created: async function() {
    if (this.$store.state.patients.length > 0) {
      this.hasPatients = true
      let defaultPatient = this.$store.state.patients.find(o => o.default === true)
      console.log(defaultPatient)
      if (defaultPatient === undefined || defaultPatient === null) {
        console.log('I ran')
        defaultPatient = this.$store.state.patients[0]
      }
      console.log(defaultPatient)
      this.seizure.patientId = defaultPatient._id
      this.selectedPatient = defaultPatient
      let seizures = await SeizureService.patientSeizures(this.seizure.patientId)
      this.selectedPatientSeizures = seizures.data
      this.precompiledSeizure()
    }
  }
}
</script>

<style lang="scss">
  #add-patient-icon {
    max-width: 150px;
    fill: #454545;
    transition: fill .5s ease;

    &:hover {
      cursor: pointer;
      fill: #FF4961;
    }
  }

  h5 {
    margin: 15px 0 20px 0;
  }
</style>
